import styled from 'styled-components';

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: auto;
  color: white;
  line-height: 1.66667;
`;
